import RequestService from "@/services/request.service";
import TokenService from "@/services/token.service";
import { AppError } from "@/services/error.service";
import { useGeneralStore } from "@/store/general.store";
import { useAuthStore } from "@/store/auth.store";
// import qs from 'qs'

const UserService = {
  /**
   * Logout the current user by removing the token from storage.
   *
   * Will also remove 'Authorization Bearer <token>' header from future requests.
   **/
  logout() {
    // Remove the token and remove Authorization header from Api Service as well
    TokenService.clear();
    const authStore = useAuthStore();
    authStore.cleanStore();
    const generalStore = useGeneralStore();
    generalStore.cleanStore();
  },

  /**
   * Get user profile data
   *
   * @returns:
   * {
   *   "id": 1,
   *   "first_name": "John",
   *   "last_name": "Doe",
   *   "email": "info@bugkings.com"
   * }
   * @throws AppError
   **/
  async getUserProfile() {
    try {
      const request = {
        method: "get",
        url: process.env.VUE_APP_AUTH_API + "api/v2/account/",
      };
      const response = await RequestService.customRequest(request);
      return response;
    } catch (error) {
      throw new AppError(error);
    }
  },
};

export default UserService;
